"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:OverlayBndSearchView");

/**
 * overlay view displaying results from search
 */
module.exports = Backbone.View.extend({

    pageModel: null,             // PageModel
    queryModel: null,            // BndPageQueryModel
    className: "overlay overlay-search",
    events: {
    },

    initialize: function (options) {
        var T = this;
        _.extend(T, options);
        if (T.hide) {
            T.$el.addClass("hide");
        }
        T.listenTo(T.pageModel, "sync", T.render);
        T.listenTo(T.queryModel, "sync", T.render);
        T.render();
    },

    render: function () {
        var T = this;

        T.$el.html("");
        if (T.queryModel.fetched && T.pageModel.fetched) {
            debug("render search page " + T.page);

            if (T.queryModel.get("hits").length) {
                var width = T.pageModel.get("width"),
                    height = T.pageModel.get("height");

                T.queryModel.get("hits").each(function (hit) {
                    var hl = hit.get("highlight");

                    if (hl && hl.positions) {

                        _.each(hl.positions, function (word_pos) {
                            var $div = $("<div/>", {
                                class: "result"
                            });
                            $div.css({
                                top: (word_pos.p[1] * 100 / height) + "%",
                                left: (word_pos.p[0] * 100 / width) + "%",
                                height: ((word_pos.p[3] - word_pos.p[1]) * 100 / height) + "%",
                                width: ((word_pos.p[2] - word_pos.p[0]) * 100 / width) + "%"
                            });
                            T.$el.append($div);
                        });
                    }

                });

            }
        }
    },

    close: function () {
        var T = this;
        T.pageModel = null;
        T.queryModel = null;
        T.stopListening();
        T.undelegateEvents();
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/views/overlay-bnd-search-view.js
// module id = 63
// module chunks = 0